import { createDefaultInstrumentPatch, normalizeInstrumentPatch } from './patchSchema';
import { normalizeSampleEntry, sampleZoneFromEntry } from './samplePool';

/** Build a playable, polyphonic instrument around one durable stock sample. */
export function stockSampleInstrumentPatch(asset) {
  const entry = normalizeSampleEntry(asset);
  if (!entry) return null;
  const base = createDefaultInstrumentPatch();
  const zone = sampleZoneFromEntry({
    ...entry,
    sourceType: asset.sourceType || 'stock',
    storageKey: asset.sourceType === 'user' ? asset.storageKey : undefined,
    assetId: asset.id,
    assetVersion: asset.version || 1
  });
  return normalizeInstrumentPatch({
    ...base,
    id: `${asset.sourceType === 'user' ? 'user-sample' : 'stock'}-${String(asset.id).slice(0, 80)}`,
    name: entry.name,
    category: entry.category || 'Sampled Instrument',
    tags: ['Sampled', entry.category].filter(Boolean),
    layers: base.layers.map((layer, index) => index === 0 ? {
      ...layer,
      engine: 'sample',
      name: entry.name,
      sampleMode: 'gate',
      sampleZones: [zone],
      level: 0.82,
      enabled: true,
      octave: 0,
      semitone: 0,
      detune: 0,
      unison: 1
    } : { ...layer, enabled: false, level: 0 }),
    ampEnvelope: { ...base.ampEnvelope, attack: 0.003, decay: 0.12, sustain: 1, release: 0.18 },
    filter: { ...base.filter, enabled: false },
    lfo: { ...base.lfo, enabled: false },
    effects: {
      ...base.effects,
      distortion: { ...base.effects.distortion, enabled: false, mix: 0 },
      chorus: { ...base.effects.chorus, enabled: false, mix: 0 },
      delay: { ...base.effects.delay, enabled: false, mix: 0 },
      reverb: { ...base.effects.reverb, enabled: false, mix: 0 },
      compressor: { ...base.effects.compressor, enabled: false }
    },
    performance: { ...base.performance, voices: 24, mono: false, legato: false }
  });
}


// Catalog entries stay lightweight. Build the editable patch only on selection.
export function stockInstrumentPreset(asset) {
  if (!asset?.id) return null;
  const stockAsset = { id: asset.id, name: asset.name, category: asset.category, musicalKey: asset.musicalKey, rootNote: asset.rootNote, version: asset.version || 1 };
  return { id: `${asset.sourceType === 'user' ? 'user-sample' : 'stock'}-${String(asset.id).slice(0, 80)}`, name: asset.name, category: asset.category || 'Sampled Instrument', tags: ['Sampled', asset.genre, asset.tone].filter(Boolean), stockAsset };
}
